module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIklEQVQ4T2NgGCTg7H/y8KgB1DPg512x/+TgUQOQDBjaAAB1hGNCpxc3ygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/UA.png
// module id = 1290
// module chunks = 0